export default "__VITE_ASSET__rmYJQhIv__"